const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        documentType: false,
        nationality: false,
        resident: false,
        typeOfRoad: false,
        province: false,
        employed_profession: false,
        employed_category: false,
        employed_accountUse_list: false,
        employed_annualIncomeAmount: false,
        selfEmployed_selfActivity: false,
        selfEmployed_accountUse_list: false,
        selfEmployed_annualIncomeAmount: false,
        rentier_accountUse_list: false,
        rentier_annualIncomeAmount: false,
        pensioner_profession: false,
        pensioner_category: false,
        pensioner_accountUse_list: false,
        pensioner_annualIncomeAmount: false,
        withoutActivity_activity: false,
        taxation_country: false,
        triggerValidations: false,
    });
};

const initialState = setInitialState();

const focusReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.SET_FOCUS:
            if (action.data == null) {
                return state;
            } else {
                return state.merge(action.data);
            }

        case actionTypes.TRIGGER_VALIDATION:
            if (action.data == null) {
                return state;
            } else {
                return state.merge({
                    triggerValidations: action.data,
                });
            }

        default:
            return state;
    }
};

module.exports = focusReducer;
